import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Footer Logo",
  icon: "list-view",
  lazyLoad: false,
}

export default defineBlock("parts/footer-logo", (props) => {
  return props.logo?.mediaItemUrl ? (
    <img className="h-8 md:h-7 w-auto inline-block max-w-[120px]" src={props.logo?.mediaItemUrl} />
  ) : env.admin ? (
    <div className="px-5 flex justify-center items-center border border-black bg-grey h-6 text-white">LOGO</div>
  ) : null
})
